import {combineReducers} from 'redux'
import Auth from './Auth'
import Clients from './Clients'
import persistStore from './persistStore'
import Common from "./Common";

const RootReducer = combineReducers({Auth,persistStore,Clients,Common});

export default RootReducer;